import React from "react";
import styled from "styled-components";

const Wrap = styled.div`
    margin-bottom: 10px;
    span {
        font-size: 14px;
        vertical-align: middle;
        color: #1e2022;

        & ~ span {
            &::before {
                content: "/";
                margin: 0 5px;
                color: #8c98a4;
            }
        }
    }

    a {
        color: #8c98a4;

        &:hover {
            color: #377dff;
        }
    }
`;
const BreadCrumb = React.memo(({arr}) => {
    return (
        <Wrap>
            {arr.map((v, i) => {
                return <span key={i}>{v}</span>;
            })}
        </Wrap>
    );
})

export default BreadCrumb;